import { HttpInterceptorFn } from '@angular/common/http';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { inject } from '@angular/core';
import { environment } from '../environments/environment';

function isExcludedUrl(url: string) {
  const { authExcludedUrls, BASE_URL } = environment;
  const baseStrippedUrl = url.replace(BASE_URL, '');

  return authExcludedUrls.some((a: string) => baseStrippedUrl.includes(a));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const token = authStore.token();
  const url = req.url || '';

  if (isExcludedUrl(url)) return next(req);

  const newReq = req.clone({
    headers: req.headers.append('Authorization', `Basic ${token}`),
  });

  return next(newReq);
};
